const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const StorePickupPackageQuery: any = {
    GetStorePickupPackageList: Backofficebff + '/v1/store/get-store-pickup-shipment',
    StorePickupShippingCompanies: Backofficebff + '/v1/cargo/companylist',
};
